const EZVOLT_PARTNER_IDS = new Set([
  'ezvolt',
  'fleet-ezvolt',
  '4e746164-9178-40e6-942d-3b18c0b2dc82',
]);

export function isEzvoltPartner(partnerId: string): boolean {
  return EZVOLT_PARTNER_IDS.has(partnerId.trim().toLowerCase());
}
